import React, { FC, useMemo } from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { MyCardItem, GetCardItem } from '@cps'
import { MktHeader } from 'pages/mkt/components'
import { useHistoryNew } from '@utils'
import './index.scss'
import mktController from 'controllers/mktController'

interface IProps extends IPage, RouteComponentProps {
}

const ActRelateCardModal: FC<IProps> = ({ location }) => {
  const history = useHistoryNew()
  let cardIds: any[] = []
  let isAllMember: boolean = false
  if (location?.state) {
    const { cardIds: _cardIds, isAllMember: _isAllMember } = location.state as any
    cardIds = _cardIds
    isAllMember = !!_isAllMember
  }

  const showCardList: any = useMemo(() => {
    let myCards: IMemberCardInfo[] = []
    let getCards: IMemberCardInfo[] = []
    if (cardIds?.length) {
      cardIds.forEach((id: number) => {
        const myInfo = memberMobx.cardList.find(item => item.cardId === id || item.card.cardId === id)
        if (myInfo) {
          myCards.push(myInfo)
        } else {
          const getInfo = memberCardMobx.cardIdMap[id]
          getInfo && getCards.push(getInfo)
        }
      })
    } else if (isAllMember) {
      myCards = memberMobx.cardList
      const getCardArr: any[] = memberCardMobx.cardList.filter((item: any) => {
        const hasItem: any = memberMobx.cardList.find((m: any) => m.cardId === item.cardId)
        return !hasItem
      })
      getCards = getCardArr
    }
    return { myCards, getCards }
  }, [cardIds, isAllMember])
  return (
    <IonPage className='activity-relate-card-modal'>
      <MktHeader onBack={() => mktController.goBack(history)} title={i18n.t('pageName.card')}></MktHeader>
      <IonContent className='page-content'>
        <div className='modal-content'>
          {
            showCardList.myCards.length > 0 && showCardList.myCards.map((item: IMemberCardInfo) => (
              <div className='card-block' key={item.cardId}>
                <MyCardItem cardInfo={item} source='activity'></MyCardItem>
              </div>
            ))
          }
          {
            showCardList.getCards.length > 0 && showCardList.getCards.map((item: IMemberCardInfo) => (
              <div className='card-block' key={item.cardId}>
                <GetCardItem cardInfo={item} isHas={false} hasDetail={false} />
              </div>
            ))
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(ActRelateCardModal)
